import { CUSTOM_ERROR } from 'config/constants';

export const customError = (message?: string): Error => {
  const error = new Error(message || 'Something went wrong!');

  error.name = CUSTOM_ERROR;

  return error;
};
